var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { xs12: "" } },
    [
      _vm.currentQuestion &&
      _vm.currentQuestion.test &&
      !_vm.exam.autoDiagnosisEnabled
        ? _c("div", { staticClass: "bg-gray p-2 mb-3" }, [
            _c("div", { staticClass: "subqueston-title" }, [
              _c(
                "div",
                { staticClass: "subqueston-title-left" },
                [
                  _vm.currentQuestion.isTestQuestion
                    ? [
                        _vm.isPass
                          ? _c("v-icon", { attrs: { color: "blue" } }, [
                              _vm._v("check"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isNotFullScore
                          ? _c("v-icon", { attrs: { color: "green" } }, [
                              _vm._v("change_history"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isNotPass
                          ? _c("v-icon", { attrs: { color: "red" } }, [
                              _vm._v("close"),
                            ])
                          : _vm._e(),
                      ]
                    : [
                        _c("v-icon", { attrs: { color: "blue" } }, [
                          _vm._v("check"),
                        ]),
                      ],
                  _vm._v(" "),
                  _vm.isMultipleQuestion
                    ? _c("span", { staticClass: "title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.groupIndex) +
                            " - " +
                            _vm._s(_vm.index) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "subqueston-title-right" }, [
                _c("span", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(
                      Math.ceil(
                        (_vm.score * 100) / _vm.currentQuestion.maxScore
                      )
                    ) + "%"
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentQuestion.isWorkSheet
        ? _c(
            "v-chip",
            {
              staticClass: "m-2",
              attrs: { color: "orange", "text-color": "white" },
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$t("question.work_sheet")) + "\n    "
              ),
              _c("v-icon", { attrs: { right: "" } }, [_vm._v("star")]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.exam.autoDiagnosisEnabled &&
      _vm.currentQuestion.isTestQuestion &&
      !_vm.userExam.finishedAt
        ? [
            _vm.userScore == _vm.maxScore
              ? [
                  _c(
                    "p",
                    { staticClass: "title m-0 result-title result-success" },
                    [
                      _c("v-icon", { attrs: { color: "rgb(4, 4, 241)" } }, [
                        _vm._v("mdi-circle-outline"),
                      ]),
                      _vm._v("正解です (" + _vm._s(_vm.maxScore) + "点)"),
                    ],
                    1
                  ),
                ]
              : _vm.userScore == 0
              ? [
                  _c(
                    "p",
                    { staticClass: "title m-0 result-title result-failed" },
                    [
                      _c("v-icon", { attrs: { color: "rgb(223, 12, 12)" } }, [
                        _vm._v("close"),
                      ]),
                      _vm._v("不正解です (0点)"),
                    ],
                    1
                  ),
                ]
              : [
                  _c(
                    "p",
                    { staticClass: "title m-0 result-title result-not-full" },
                    [
                      _c("v-icon", { attrs: { color: "rgb(1, 156, 1)" } }, [
                        _vm._v("mdi-triangle-outline"),
                      ]),
                      _vm._v(
                        _vm._s(_vm.getRateScore(_vm.userScore, _vm.maxScore)) +
                          "% 正解です (" +
                          _vm._s(_vm.userScore) +
                          "/" +
                          _vm._s(_vm.maxScore) +
                          "点)"
                      ),
                    ],
                    1
                  ),
                ],
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "p-2 mb-4" }, [
        _vm.show
          ? _c("div", {
              staticClass: "question-body-preview-client subheading",
              domProps: { innerHTML: _vm._s(_vm.content) },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.currentQuestion.isTextarea
            ? _c("div", [
                _c("div", {
                  staticClass: "textarea-preview mt-0 p-3 mb-1",
                  attrs: { readonly: "" },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.markdownParser(_vm.value.length ? _vm.value[0] : "")
                    ),
                  },
                }),
              ])
            : _vm.currentQuestion.isCheckbox ||
              _vm.currentQuestion.isMultiCheckbox ||
              _vm.currentQuestion.isSelect
            ? _c("QuestionCheckBox", {
                attrs: {
                  list: _vm.currentQuestion.answerItemsView
                    ? _vm.currentQuestion.answerItemsView
                    : [],
                  trueBgr: _vm.exam.autoDiagnosisEnabled ? "#fff" : "#bce0fd",
                  value: _vm.value ? _vm.value : [],
                  readonly: "",
                },
              })
            : _vm.currentQuestion.isRadio
            ? _c("QuestionRadio", {
                attrs: {
                  list: _vm.currentQuestion.answerItemsView
                    ? _vm.currentQuestion.answerItemsView
                    : [],
                  trueBgr: _vm.exam.autoDiagnosisEnabled ? "#fff" : "#bce0fd",
                  value: _vm.value.length
                    ? _vm.value.find(function (x) {
                        return !!x
                      })
                    : "",
                  readonly: "",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.currentQuestion.skills.length > 0 || _vm.explanation
            ? [
                _c(
                  "v-flex",
                  { staticClass: "explain-title p-2 text-secondary" },
                  [_vm._v("解説")]
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { staticClass: "bg-white p-2 mb-4" },
                  [
                    _vm._l(_vm.currentQuestion.skills, function (skill, index) {
                      return _c(
                        "p",
                        { key: skill.name + index, staticClass: "skill-text" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(skill.name) +
                              " > " +
                              _vm._s(_vm.skillItemsName(skill)) +
                              "\n        "
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "exam-explain",
                      domProps: { innerHTML: _vm._s(_vm.explanation) },
                    }),
                  ],
                  2
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.qScoreHistorySummary &&
          _vm.currentQuestion.isTestQuestion &&
          _vm.qScoreHistorySummary.totalCount > 1
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "explain-title m-0 ps-1 text-secondary d-flex py-1 align-center",
                  },
                  [
                    _vm._v(
                      "\n        正解率 " +
                        _vm._s(_vm.qScoreHistorySummary.rate) +
                        "%(" +
                        _vm._s(_vm.qScoreHistorySummary.successCount) +
                        "/" +
                        _vm._s(_vm.qScoreHistorySummary.totalCount) +
                        ")\n        "
                    ),
                    _c("div", { staticClass: "text-gray ms-1 text-caption" }, [
                      _vm._v(
                        "いままで " +
                          _vm._s(_vm.qScoreHistorySummary.totalCount) +
                          "回やって" +
                          _vm._s(_vm.qScoreHistorySummary.successCount) +
                          "回正解しています"
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ps-2" },
                  _vm._l(
                    _vm.qScoreHistorySummary.histories,
                    function (history, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "d-flex" },
                        [
                          _c("v-col", { attrs: { cols: "3" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.dateFormat(history.createdAt)) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { staticClass: "blue-text", attrs: { cols: "3" } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    history.score > 0 ? "正解" : "不正解"
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-col", { attrs: { cols: "6" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.examQScoreHistory.examName) +
                                " - " +
                                _vm._s(
                                  _vm.getNameByExamType(history.examType)
                                ) +
                                "\n          "
                            ),
                          ]),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.currentQuestion.coursesWithLessons.length > 0 &&
          _vm.schoolSetting.useCourseLesson
            ? [
                _c(
                  "v-flex",
                  { staticClass: "explain-title p-2 text-secondary" },
                  [_vm._v("参考レッスン")]
                ),
                _vm._v(" "),
                _vm._l(
                  _vm.currentQuestion.coursesWithLessons,
                  function (courseWithLessons) {
                    return _c(
                      "v-flex",
                      {
                        key: courseWithLessons.course.id,
                        staticClass: "bg-white p-2",
                      },
                      [
                        _c("router-link", {
                          attrs: {
                            target: "_blank",
                            to:
                              "/classroom/courses/" +
                              courseWithLessons.course.id,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var href = ref.href
                                  return [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: href, target: "_blank" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(courseWithLessons.course.name)
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _vm._v(" "),
                        _vm._l(courseWithLessons.lessons, function (lesson) {
                          return _c(
                            "div",
                            { key: lesson.id, staticClass: "lesson-margin" },
                            [
                              _c("router-link", {
                                attrs: {
                                  target: "_blank",
                                  to:
                                    "/classroom/courses/" +
                                    courseWithLessons.course.id +
                                    "?lesson_id=" +
                                    lesson.id,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var href = ref.href
                                        return [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: href,
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v(_vm._s(lesson.name))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    )
                  }
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }